"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
function SvgPasswordHide(props) {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M10 14c-2 1-5 4-6 5.727C8.776 25.91 14.109 29 20 29c1.791 0 4-1 4-1M28.343 26.725c2.695-1.545 5.247-3.878 7.657-6.998C31.224 13.91 25.891 11 20 11c-2.07 0-4.07.359-6 1.077", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M20 13.929a6 6 0 014.292 10.192l-8.482-8.487A5.98 5.98 0 0120 13.929zM20 25.929a6 6 0 01-5.338-8.743l8.068 8.087a5.974 5.974 0 01-2.73.656z", fill: "currentColor" }, void 0), (0, jsx_runtime_1.jsx)("path", { d: "M8.456 5.55A1 1 0 107.04 6.961l1.416-1.413zM32.43 32.404a1 1 0 001.416-1.413l-1.416 1.413zM7.04 6.962l25.39 25.443 1.416-1.413L8.456 5.549 7.04 6.962z", fill: "currentColor" }, void 0)] }), void 0));
}
exports.default = SvgPasswordHide;
//# sourceMappingURL=PasswordHide.js.map